import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_GeneralInfo = _resolveComponent("GeneralInfo")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_Passwords = _resolveComponent("Passwords")!
  const _component_PaymentSystemAccounts = _resolveComponent("PaymentSystemAccounts")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "dashboard__page" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        modelValue: _ctx.profileTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profileTab) = $event)),
        "inline-label": "",
        breakpoint: 0,
        align: "justify",
        style: {"background-color":"#252c3e","margin-bottom":"25px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: "general",
            label: _ctx.$t('pages.profile.tabPersonal')
          }, null, 8, ["label"]),
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: "passwords",
            label: _ctx.$t('pages.profile.tabPassword')
          }, null, 8, ["label"]),
          _createVNode(_component_q_tab, {
            "no-caps": "",
            name: "payments",
            label: _ctx.$t('pages.profile.tabPayment')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_tab_panels, {
        modelValue: _ctx.profileTab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profileTab) = $event)),
        animated: "",
        class: "bg-transparent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, { name: "general" }, {
            default: _withCtx(() => [
              _createVNode(_component_GeneralInfo)
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, { name: "passwords" }, {
            default: _withCtx(() => [
              _createVNode(_component_Passwords)
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, { name: "payments" }, {
            default: _withCtx(() => [
              _createVNode(_component_PaymentSystemAccounts)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}